import { GET_HOTEL_INVENTORY_QUERY, GET_ROOM_TYPE_INFORMATION_QUERY } from '@whitbread-eos/api';
import { useCustomLocale, useQueryRequest, useStaticHotelInformation } from '@whitbread-eos/utils';
import HotelRoomsComponent from './HotelRooms.component';
import { jsx as _jsx } from "react/jsx-runtime";
function PremierInnHotelRooms(_ref) {
  var isPremierInn = _ref.isPremierInn,
    isLessThanSm = _ref.isLessThanSm,
    isLessThanMd = _ref.isLessThanMd,
    isLessThanLg = _ref.isLessThanLg,
    isDisplayRates = _ref.isDisplayRates;
  var _useStaticHotelInform = useStaticHotelInformation(),
    roomConfiguration = _useStaticHotelInform.roomConfiguration,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error,
    brand = _useStaticHotelInform.brand;
  return _jsx(HotelRoomsComponent, {
    isLoading,
    isError,
    error,
    data: roomConfiguration,
    isPremierInn,
    isLessThanSm,
    isLessThanMd,
    isLessThanLg,
    isDisplayRates,
    brand
  });
}
function CCUIHotelRooms(_ref2) {
  var isPremierInn = _ref2.isPremierInn,
    isLessThanSm = _ref2.isLessThanSm,
    isLessThanMd = _ref2.isLessThanMd,
    isLessThanLg = _ref2.isLessThanLg,
    dateRangeStart = _ref2.arrival,
    dateRangeEnd = _ref2.departure;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useStaticHotelInform2 = useStaticHotelInformation(),
    roomConfiguration = _useStaticHotelInform2.roomConfiguration,
    hotelId = _useStaticHotelInform2.hotelId,
    brand = _useStaticHotelInform2.brand,
    isLoading = _useStaticHotelInform2.isLoading,
    isError = _useStaticHotelInform2.isError,
    error = _useStaticHotelInform2.error;
  var queryEnabled = dateRangeStart !== undefined && dateRangeEnd !== undefined;
  var _useQueryRequest = useQueryRequest(['getHotelInventory', hotelId, dateRangeEnd, dateRangeStart], GET_HOTEL_INVENTORY_QUERY, {
      hotelId,
      dateRangeEnd,
      dateRangeStart
    }, {
      gcTime: 0,
      enabled: !!queryEnabled
    }),
    isLoadingHotelInventory = _useQueryRequest.isLoading,
    isErrorHotelInventory = _useQueryRequest.isError,
    dataHotelInventory = _useQueryRequest.data,
    errorHotelInventory = _useQueryRequest.error;
  var hotelInventoryResponse = {
    isLoadingHotelInventory,
    isErrorHotelInventory,
    dataHotelInventory: dataHotelInventory,
    errorHotelInventory
  };
  var _useQueryRequest2 = useQueryRequest(['getRoomTypeInformation', language, country, brand, hotelId], GET_ROOM_TYPE_INFORMATION_QUERY, {
      language,
      country,
      brand,
      hotelId
    }),
    isLoadingRoomTypeInformation = _useQueryRequest2.isLoading,
    isErrorRoomTypeInformation = _useQueryRequest2.isError,
    dataRoomTypeInformation = _useQueryRequest2.data,
    errorRoomTypeInformation = _useQueryRequest2.error;
  var roomTypeInformationResponse = {
    isLoadingRoomTypeInformation,
    isErrorRoomTypeInformation,
    dataRoomTypeInformation: dataRoomTypeInformation,
    errorRoomTypeInformation
  };
  return _jsx(HotelRoomsComponent, {
    isLoading,
    isError,
    error,
    data: roomConfiguration,
    hotelInventoryResponse,
    roomTypeInformationResponse,
    isPremierInn,
    isLessThanSm,
    isLessThanMd,
    isLessThanLg,
    brand
  });
}
export default function HotelRoomsContainer(_ref3) {
  var isPremierInn = _ref3.isPremierInn,
    isLessThanSm = _ref3.isLessThanSm,
    isLessThanMd = _ref3.isLessThanMd,
    isLessThanLg = _ref3.isLessThanLg,
    arrival = _ref3.arrival,
    departure = _ref3.departure,
    isDisplayRates = _ref3.isDisplayRates;
  return isPremierInn ? _jsx(PremierInnHotelRooms, {
    isPremierInn,
    isLessThanSm,
    isLessThanMd,
    isLessThanLg,
    isDisplayRates
  }) : _jsx(CCUIHotelRooms, {
    isPremierInn,
    isLessThanSm,
    isLessThanMd,
    isLessThanLg,
    arrival,
    departure
  });
}